import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Hero from "@/components/sections/Hero";
import StatsBar from "@/components/sections/StatsBar";
import Features from "@/components/sections/Features";
import WhyFestivalPlan from "@/components/sections/WhyFestivalPlan";
import Download from "@/components/sections/Download";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <StatsBar />
      <WhyFestivalPlan />
      <Features
        footer={
          <Link
            to="/features"
            data-testid="home-all-features-link"
            className="group inline-flex items-center gap-2 text-sm font-medium text-[#00E5FF] transition-colors hover:text-white"
          >
            Alle Funktionen im Detail
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
        }
      />
      <Download />
    </div>
  );
}
